import { graphql } from '@/gql';
import type { RaiseQaCalibrationDisputeMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const raiseQaCalibrationDispute = async (data: RaiseQaCalibrationDisputeMutationVariables['data']) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation RaiseQaCalibrationDispute($data: RaiseQaCalibrationDisputeInput!) {
        raiseQaCalibrationDispute(data: $data) {
          id
        }
      }
    `),
  });

  return response.data?.raiseQaCalibrationDispute;
};
